import { render, staticRenderFns } from "./ManageCampaigns.vue?vue&type=template&id=506bd16c&"
import script from "./ManageCampaigns.vue?vue&type=script&lang=js&"
export * from "./ManageCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports